import { render } from "./DriverDetails.vue?vue&type=template&id=567b40d1&scoped=true"
import script from "./DriverDetails.vue?vue&type=script&lang=js"
export * from "./DriverDetails.vue?vue&type=script&lang=js"

import "./DriverDetails.vue?vue&type=style&index=0&id=567b40d1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-567b40d1"]])

export default __exports__